import React from "react";

function defaultButton (props: {
    content: React.ReactNode,
    onClick: any,
    disabled?: boolean,
    className?: string
}){
    const widthClass = props.className?.includes("min-w-") || props.className?.includes("w-") ? "" : "min-w-40";

    return (
        <button
            type="button"
            className={`flex bg-blue-800 hover:bg-blue-900 text-white cursor-pointer items-center justify-center ${widthClass} px-4 p-2 h-9 shadow-[0_4px_10px_rgba(0,0,0,0.03)] text-base font-normal transition-colors rounded-lg ${props.disabled ? "opacity-50 cursor-not-allowed" : ""} ${props.className || ""}`}
            disabled={props.disabled}
            onClick={!props.disabled ? props.onClick : undefined}
        >
            {props.content}
        </button>
    );
}

export default defaultButton;
